import React from 'react';

import { Download } from 'lucide-react'
import { Button, DropdownMenuItem } from 'twyne-new.ui'

import { HeaderSeparator, ReportDatePicker, ReportHeader, ReportHeaderDates, ReportHeaderDesktopActions, ReportHeaderMobileActions, ReportMenuConfigure, ReportMobileMenu, RunButton } from '@/components/reports/header'

function ReportsSweepWinnerHeader(props) {
  const {
    onChangeDates,
    onClickExport,
    dates,
    sync,
    isLoading,
    children,
  } = props

  return (
    <>
      <ReportHeader title='Sweep Winner Report'>
        <ReportHeaderDates>
          <ReportDatePicker dates={dates} onChange={onChangeDates} />
        </ReportHeaderDates>
        <HeaderSeparator />
        <ReportHeaderDesktopActions>
          <Button size="lg" variant='outline' onClick={onClickExport} >Export</Button>
          {children}
        </ReportHeaderDesktopActions>
        <ReportHeaderMobileActions>
          <ReportMobileMenu>
            <ReportMenuConfigure />
            <DropdownMenuItem icon={Download} onSelect={onClickExport}>Export</DropdownMenuItem>
          </ReportMobileMenu>
          <RunButton isLoading={isLoading} disabled={isLoading} onClick={sync} />
        </ReportHeaderMobileActions>
      </ReportHeader>
    </>
  )
}

export default ReportsSweepWinnerHeader
